import React, { useEffect, useRef, useState } from 'react';
import { apiDelete, apiGet, apiUpload } from '../../api/client';

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = async () => {
    setLoading(true);
    try {
      const data = await apiGet('/admin/media?limit=200');
      setItems(data.items || []);
      setTotal(data.total || 0);
    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    setMessage('');
    try {
      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        await apiUpload('/admin/media', formData);
      }
      setMessage(`Uploaded ${files.length} image${files.length === 1 ? '' : 's'}.`);
      await load();
    } catch (err) {
      setMessage(err.message);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this image from the library?')) return;
    setMessage('');
    try {
      await apiDelete(`/admin/media/${id}`);
      setMessage('Image deleted.');
      await load();
    } catch (err) {
      setMessage(err.message);
    }
  };

  const copyUrl = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      setMessage('URL copied to clipboard.');
    } catch {
      setMessage(url);
    }
  };

  return (
    <div className="admin-panel-page">
      <div className="admin-settings-card admin-settings-card--wide">
        <h3>Media library</h3>
        <p>Upload images for tools, reviews, tool pages, and SEO. JPEG, PNG, WebP, or GIF — max 5 MB each.</p>
        <div className="admin-settings-actions">
          <button type="button" className="btn btn-primary" onClick={() => fileRef.current?.click()} disabled={uploading}>
            {uploading ? 'Uploading…' : 'Upload images'}
          </button>
          <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple hidden onChange={handleUpload} />
        </div>
        {message && <p className="admin-message" style={{ marginTop: '0.5rem' }}>{message}</p>}
      </div>

      <div className="admin-settings-card admin-settings-card--wide">
        <h3>{total} file{total === 1 ? '' : 's'}</h3>
        {loading ? (
          <p>Loading…</p>
        ) : items.length === 0 ? (
          <p>No uploads yet.</p>
        ) : (
          <div className="admin-media-grid">
            {items.map((item) => (
              <div key={item.id} className="admin-media-grid__item">
                <img src={item.url} alt={item.originalName} />
                <div className="admin-media-grid__meta">
                  <span title={item.originalName}>{item.originalName}</span>
                  <code>{item.url}</code>
                </div>
                <div className="admin-media-grid__actions">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => copyUrl(item.url)}>
                    Copy URL
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleDelete(item.id)}>
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
